import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'whatwg-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
// 针对ant的全局化配置
import { ConfigProvider } from "antd";
// 导入中文包
import zhCN from "antd/lib/locale/zh_CN";

import App from './App';
import * as serviceWorker from './serviceWorker';

import './index.css';
// import "antd/dist/antd.css";



ReactDOM.render (
  
    <ConfigProvider locale={zhCN}>
      <React.StrictMode>
      <App />
      </React.StrictMode>
    </ConfigProvider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
